/*
 * Jira Ticket:
 * Created Date: Mon, 23rd Mar 2020, 14:32:56 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { Fragment, useEffect } from 'react';
import { required, SelectInput, TextInput } from 'react-admin';
import { useForm } from 'react-final-form';
import { columnStyles } from 'styles';
import { booleanOptions } from 'utils/choices';
import { isValidEmail } from 'utils/validation';

const emailValidation = [required(), email => isValidEmail(email)];

const OverviewTab = ({ record, isSuperAdmin }) => {
  const classes = columnStyles();
  const form = useForm();

  // console.log('OverviewTab record', record);
  const { certificateNumber } = record;
  const editDisabled = record.hasAccount === false;
  useEffect(() => {
    const initialiseDefaultValue = () => {
      const initialValues =
        record &&
        record.employments &&
        record.employments
          .filter(
            employment =>
              employment.status !== 'REVOKED' &&
              employment.status !== 'REJECTED'
          )
          .map(employment => {
            return employment.organisation.id;
          });
      return form.change('organisationIds', initialValues);
    };
    initialiseDefaultValue();
  }, [form, record]);

  return (
    <Fragment>
      <div className={classes.root}>
        <div className={classes.column}>
          <TextInput
            source="givenName"
            label={'resources.User.fields.givenName'}
            validate={required()}
            disabled={editDisabled || (certificateNumber ? true : false)}
          />
          <TextInput
            source="familyName"
            label={'resources.User.fields.familyName'}
            validate={required()}
            disabled={editDisabled || (certificateNumber ? true : false)}
          />
          <TextInput
            source="status"
            label={'resources.User.fields.UserStatus'}
            disabled={true}
          />
        </div>
        <div className={classes.column}>
          <TextInput
            source="email"
            label={'resources.User.fields.emailAddress'}
            validate={emailValidation}
            disabled={editDisabled}
          />
          <TextInput
            source="certificateNumber"
            label={'resources.User.fields.certNum'}
            disabled={editDisabled }
          />
        </div>
        <div className={classes.column}>
          <SelectInput
            source="isAdmin"
            label={'resources.User.fields.isAdmin'}
            choices={booleanOptions}
            disabled={editDisabled || !isSuperAdmin}
          />
          <TextInput
            source="position"
            label={'resources.User.fields.position'}
            validate={required()}
            disabled={editDisabled}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default OverviewTab;
